export const CONTACT_STORE = 'CONTACT_STORE';
export const CONTACT_UPDATE = 'CONTACT_UPDATE';
export const CONTACT_DESTROY = 'CONTACT_DESTROY';
